/* 
* Palo Alto Theme 
* 
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom 
* Javascript in this fill will make it easier to update Palo Alto. In order 
* to use this file you will need to open layout/theme.liquid and uncomment 
* the custom.js script import line near the bottom of the file. 
*/ 
 
 
(function() { 
  // Add custom code below this line 
 
  /*
   * ============================================================
   * MILOUA — GLOBAL CART ONLY
   * ============================================================
   *
   * Prevent Palo Alto's native cart drawer from opening when the
   * MILOUA Global Cart is present.
   *
   * Shopify's real cart, pricing, discounts and checkout remain
   * unchanged.
   */
 
  const hasMilouaGlobalCart = function() {
    return Boolean(
      document.querySelector(
        '[data-miloua-global-cart]'
      )
    );
  };
 
  const rememberMilouaCartOpener = function(element) {
    if (
      element &&
      typeof element.focus === 'function'
    ) {
      window.__milouaCartPendingOpener =
        element;
    }
  };
 
  const openMilouaGlobalCart = function(opener) {
    if (!hasMilouaGlobalCart()) return;
 
    rememberMilouaCartOpener(opener);
 
    document.dispatchEvent(
      new CustomEvent(
        'miloua:cart-open',
        {
          detail: {
            opener:
              opener ||
              window.__milouaCartPendingOpener ||
              document.activeElement
          }
        }
      )
    );
  };
 
  const closePaloAltoCart = function(cart) {
    if (!cart) return;
 
    if (
      cart.isCartDrawerOpen &&
      typeof cart.closeCartDrawer ===
        'function'
    ) {
      try {
        cart.closeCartDrawer();
      } catch (error) {}
    }
 
    cart.classList.remove('is-open');
 
    document.body.classList.remove(
      'js-drawer-open-cart'
    );
 
    cart
      .querySelectorAll(
        '[data-cart-drawer-toggle]'
      )
      .forEach(function(button) {
        button.setAttribute(
          'aria-expanded',
          'false'
        );
      });
 
    cart.isCartDrawerOpen = false;
  };
 
  const patchPaloAltoCart = function(cart) {
    if (
      !cart ||
      cart.__milouaGlobalCartOnly
    ) {
      return;
    }
 
    const originalOpenCartDrawer =
      cart.openCartDrawer;
 
    const originalToggleCartDrawer =
      cart.toggleCartDrawer;
 
    cart.openCartDrawer = function() {
      if (
        hasMilouaGlobalCart() &&
        this.isCartDrawer
      ) {
        closePaloAltoCart(this);
        openMilouaGlobalCart(
          window.__milouaCartPendingOpener
        );
        return;
      }
 
      return originalOpenCartDrawer.apply(
        this,
        arguments
      );
    };
 
    cart.toggleCartDrawer = function() {
      if (
        hasMilouaGlobalCart() &&
        this.isCartDrawer
      ) {
        closePaloAltoCart(this);
 
        openMilouaGlobalCart(
          window.__milouaCartPendingOpener ||
          document.activeElement
        );
 
        return;
      }
 
      return originalToggleCartDrawer.apply(
        this,
        arguments
      );
    };
 
    cart.__milouaGlobalCartOnly = true;
 
    closePaloAltoCart(cart);
  };
 
  const patchAllPaloAltoCarts = function() {
    if (!hasMilouaGlobalCart()) return;
 
    document
      .querySelectorAll(
        'cart-element[data-cart-drawer]'
      )
      .forEach(function(cart) {
        patchPaloAltoCart(cart);
      });
  };
 
  /*
   * Remember the exact Quick Add / Add to Cart button before
   * Palo Alto disables it during the Ajax request.
   */
 
  document.addEventListener(
    'click',
    function(event) {
      if (!hasMilouaGlobalCart()) return;
 
      const addButton =
        event.target.closest(
          '[data-add-to-cart]'
        );
 
      if (!addButton) return;
 
      rememberMilouaCartOpener(
        addButton
      );
    },
    true
  );
 
  /*
   * Make sure any Palo Alto cart already on the page is patched
   * after its custom element has been registered.
   */
 
  if (
    window.customElements &&
    typeof customElements.whenDefined ===
      'function'
  ) {
    customElements
      .whenDefined('cart-element')
      .then(function() {
        patchAllPaloAltoCarts();
      });
  } else {
    patchAllPaloAltoCarts();
  }
 
  /*
   * If Shopify reloads a section containing the cart, patch the
   * replacement cart as well.
   */
 
  document.addEventListener(
    'shopify:section:load',
    function() {
      patchAllPaloAltoCarts();
    }
  );
 
  /*
   * Whenever MILOUA opens its cart, make certain the Palo Alto
   * drawer is closed.
   */
 
  document.addEventListener(
    'miloua:cart-open',
    function() {
      document
        .querySelectorAll(
          'cart-element[data-cart-drawer]'
        )
        .forEach(function(cart) {
          closePaloAltoCart(cart);
        });
    }
  );
 
 
 
 
 
 
 
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope. 
})(); 